module.exports = __webpack_public_path__ + "img/22.357ef113.png";